import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Steven, ELEMENT_TYPES } from 'helpers/steven';
import CCModal from 'components/shared/DesignSystem/CCModal/CCModal';
import DeletedAssets from './DeletedAssets';
import Tabs from 'components/shared/Tabs';
import ComingSoonImage from 'images/RickGetsToWork.png';
import TrashCanMessage from './TrashCanMessage';
import { translate } from 'translations/i18n';

// #region styled-components
const Heading = styled.h2`
  margin: 0 0 var(--cc_size_spacing_s);
  font-size: var(--cc_size_text_xl);
  font-weight: 800;
`;
const Intro = styled.p`
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_xs);
  margin: 0 0 var(--cc_size_spacing_xs);
`;
const IntroIcon = styled.i`
  color: var(--cc_color_text_subtle);
  font-size: var(--cc_size_text_m);
`;
const IntroText = styled.span`
  color: var(--cc_color_text_subtle);
  font-size: var(--cc_size_text_s);
  line-height: calc(var(--cc_size_text_s) + 4px);
`;
// #endregion

const TrashCanModal = ({ onRequestClose, projectId }) => {

  const handleTabSelected = (tabLabel) => {
    const action = `projects_trash_can_modal_${tabLabel}_tab_selected`;
    const trackingContent = `Projects Trash Can Modal Selected Tab: ${tabLabel}`;

    Steven.elementClicked({
      id: 'projects_trash_can_modal_tab',
      content: trackingContent,
      type: ELEMENT_TYPES.BUTTON,
      action,
    });
  };

  return (
    <CCModal
      size="large"
      isOpen
      onRequestClose={onRequestClose}
      title={
        <>
          <Heading>{translate('project.trashCan.title')}</Heading>
          <Intro>
            <IntroIcon aria-hidden="true" className="mdi mdi-delete-empty" />
            <IntroText>{translate('project.trashCan.introMessage')}</IntroText>
          </Intro>
        </>
      }
      label="Project Trash"
      bodyStyle={{
        padding: 0,
      }}
      headerStyle={{
        borderBottomWidth: 0,
        paddingBlockEnd: 0,
      }}
    >
      <Tabs
        id="project-trash-modal"
        onTabSelected={handleTabSelected}
        style={{
          backgroundColor: 'var(--cc_color_background_2)',
          borderRadius: 'var(--cc_size_border_radius_xl)',
        }}
        tabListStyle={{
          padding: '0 var(--cc_size_spacing_xl)',
          backgroundColor: 'var(--cc_color_background_1)',
        }}
        tabContentStyle={{
          padding: 0,
          position: 'relative',
        }}
      >
        <div label="Photos">
          <DeletedAssets projectId={projectId} />
        </div>
        <div label="Documents">
          <TrashCanMessage
            contentBefore={
              <img width="150" height="134" src={ComingSoonImage} alt="" />
            }
            heading={translate('common.comingSoon')}
            message={translate('project.trashCan.documentsComingSoon')}
          />
        </div>
        <div label="Reports">
          <TrashCanMessage
            contentBefore={
              <img width="150" height="134" src={ComingSoonImage} alt="" />
            }
            heading={translate('common.comingSoon')}
            message={translate('project.trashCan.reportsComingSoon')}
          />
        </div>
      </Tabs>
    </CCModal>
  );
};

TrashCanModal.propTypes = {
  onRequestClose: PropTypes.func,
  projectId: PropTypes.number,
};

export default TrashCanModal;
